module.exports = __webpack_public_path__ + "img/principal.ba13e783.jpg";